import { useContext } from 'react';
import { ConfigContext, ConfigContextType } from 'contexts/ConfigContext';

// ==============================|| CONFIG - HOOK ||============================== //

export default function useConfig(): ConfigContextType {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error('useConfig must be used inside a ConfigProvider');
  }

  return context;
}
